import React from 'react';
import PolicyPageEditor from '../PolicyPageEditor';

const PrivacyPolicy = () => (
  <PolicyPageEditor pageType="privacy-policy" pageTitle="Privacy Policy" />
);

export default PrivacyPolicy;
